import { FunctionComponent } from "react";
import { IIconProps } from "./icon";

export const Cancel: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;

  return (
    <svg
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...rest}
    >
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Icons/Base/Cancel" stroke="#222222" strokeWidth="2">
          <g id="Group" transform="translate(6.350000, 6.350000)">
            <line x1="0" y1="0" x2="11.3137085" y2="11.3137085" id="Line-3"></line>
            <line
              x1="0"
              y1="0"
              x2="11.3137085"
              y2="11.3137085"
              id="Line-3-Copy"
              transform="translate(5.656854, 5.656854) scale(-1, 1) translate(-5.656854, -5.656854) "
            ></line>
          </g>
        </g>
      </g>
    </svg>
  );
};
